import React from 'react';
import { H2, P, OL, LI, Callout, FeatureLink } from './_shared';

export default {
  slug: 'data-rights',
  title: 'Data export & deletion (CCPA / CPRA)',
  category: 'account',
  summary: 'Download a JSON export of everything in your account, or request deletion. 30-day grace window.',
  searchTerms: ['ccpa', 'cpra', 'gdpr', 'data export', 'delete account', 'dsr', 'privacy'],
  related: ['compliance'],
  Body: () => (
    <>
      <P>
        Under California CCPA/CPRA (and equivalent laws elsewhere), you have
        the right to a full export of your data and the right to deletion.
        Both are self-service.
      </P>

      <H2>Exporting</H2>
      <OL>
        <LI>Go to <FeatureLink to="/settings/data-rights">Settings → Data Rights</FeatureLink>.</LI>
        <LI>Click "Request Export." A JSON archive is generated within a few minutes.</LI>
        <LI>Download link is emailed to your account address. Link is valid for 7 days.</LI>
      </OL>
      <P>
        The export includes: profile, all clients, all deals, all folders +
        documents (PDF files inline as base64), full activity log, integration
        configs (with secrets redacted), and your AI usage history.
      </P>

      <H2>Deleting</H2>
      <OL>
        <LI>Same screen → "Request Deletion."</LI>
        <LI>Confirm via the link emailed to you.</LI>
        <LI>Your account moves to "scheduled for deletion" — 30-day grace window starts.</LI>
        <LI>During the grace window, log back in and click "Cancel Deletion" to restore.</LI>
        <LI>After 30 days, your data is irreversibly removed from active databases. Tax-required transaction records are retained per state law (7 years).</LI>
      </OL>

      <Callout kind="warn">
        Deletion does not propagate to your team's records if you were on a
        team plan. Records you created in a team workspace stay with the
        team for compliance reasons; your name in the audit log is replaced
        with "(deleted user)."
      </Callout>
    </>
  ),
};
